import React from 'react'

const SideBarBg = ({ background }) => {
  return (
    <svg
      width='472'
      height='900'
      viewBox='0 0 472 900'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <mask
        id='mask0_2746_4437'
        style={{ maskType: 'alpha' }}
        maskUnits='userSpaceOnUse'
        x='0'
        y='0'
        width='472'
        height='900'
      >
        <rect
          width='472'
          height='900'
          transform='matrix(-1 0 0 1 472 0)'
          fill='#215F83'
        />
      </mask>
      <g mask='url(#mask0_2746_4437)'>
        <rect
          width='472'
          height='900'
          transform='matrix(-1 0 0 1 472 0)'
          fill={background}
        />
        <g style={{ mixBlendMode: 'overlay' }} opacity='0.1'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M352 -69L274 -23.999V66.001L352 111L430 66.001V-23.999L352 -69Z'
            fill='white'
            style={{ mixBlendMode: 'multiply' }}
          />
        </g>
        <g style={{ mixBlendMode: 'overlay' }} opacity='0.1'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M439 -25L327 39.5015V168.501L439 233L551 168.501V39.5015L439 -25Z'
            fill='white'
            style={{ mixBlendMode: 'multiply' }}
          />
        </g>
        <g opacity='0.05'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M82.5264 700C34.6163 700 -17.8541 724.484 -54.185 755.892C-72.2822 771.547 -88.0347 791.49 -92.6178 815.029C-99.2875 849.233 -80.9552 884.016 -56.211 908.462C-21.2535 943.001 27.8631 962 76.8051 962C95.4107 962 114.001 959.258 131.78 953.575C158.618 944.989 184.432 929.289 198.697 904.897C215.998 875.324 213.562 837.38 200.617 805.636C187.672 773.893 168.793 736.337 149.292 721.239C130.012 706.315 106.861 700 82.5264 700Z'
            fill='black'
            style={{ mixBlendMode: 'multiply' }}
          />
        </g>
        <g opacity='0.05'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M161.898 960C212.95 960 268.861 933.928 307.574 900.481C326.858 883.811 343.644 862.573 348.527 837.507C355.634 801.084 336.1 764.044 309.733 738.012C272.483 701.232 220.146 681 167.995 681C148.169 681 128.36 683.92 109.415 689.972C80.817 699.114 53.3102 715.833 38.1095 741.808C19.6746 773.3 22.27 813.706 36.0638 847.509C49.8577 881.312 69.9743 921.305 90.754 937.383C111.299 953.275 135.968 960 161.898 960Z'
            fill='black'
            style={{ mixBlendMode: 'multiply' }}
          />
        </g>
        <g style={{ mixBlendMode: 'overlay' }} opacity='0.05'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M185 560L47 639.752V799.252L185 879L323 799.252V639.752L185 560Z'
            fill='black'
            style={{ mixBlendMode: 'multiply' }}
          />
        </g>
      </g>
    </svg>
  )
}

export default SideBarBg
